var _excluded = ["style", "shouldResetOnMove"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useCallback, useEffect, useMemo } from 'react';
import { useOpenLayers } from '../../react-ol';
import { useVectorLayer } from '../useVectorLayer';
import { mapStructToInstance } from './../../react-ol/hooks/styles';
export function useHighlightFeatureById(params) {
  var {
    style,
    shouldResetOnMove = false
  } = params,
      rest = _objectWithoutProperties(params, _excluded);

  var vectorLayer = useVectorLayer(_objectSpread(_objectSpread({}, rest), {}, {
    label: rest.id
  }));
  var {
    map
  } = useOpenLayers();
  var styles = useMemo(() => mapStructToInstance(style), [style]);
  useEffect(() => {
    if (styles) {
      vectorLayer.setStyle([styles]);
    }
  }, [styles, vectorLayer]);
  useEffect(() => {
    if (!map || !shouldResetOnMove) return;

    var clearHighlightFeature = () => {
      var _vectorLayer$getSourc;

      (_vectorLayer$getSourc = vectorLayer.getSource()) === null || _vectorLayer$getSourc === void 0 ? void 0 : _vectorLayer$getSourc.clear();
    };

    map.on('pointermove', clearHighlightFeature);
    return () => map.un('pointermove', clearHighlightFeature);
  }, [map, shouldResetOnMove, vectorLayer]);
  var highlightFeatureById = useCallback((featureId, featureLayerId) => {
    var _targetLayer$getSourc, _vectorLayer$getSourc2, _vectorLayer$getSourc3;

    var targetLayer = map === null || map === void 0 ? void 0 : map.getLayers().getArray().find(layer => layer.get('id') === featureLayerId);

    if (!targetLayer) {
      console.error("Cannot find layer with ID:".concat(featureLayerId));
      return;
    }

    var targetFeature = targetLayer === null || targetLayer === void 0 ? void 0 : (_targetLayer$getSourc = targetLayer.getSource()) === null || _targetLayer$getSourc === void 0 ? void 0 : _targetLayer$getSourc.getFeatureById(featureId);

    if (!targetFeature) {
      console.error("Cannot find feature with ID:".concat(featureId));
      return;
    } // Clear previously highlighted feature and hightlight current feature


    (_vectorLayer$getSourc2 = vectorLayer.getSource()) === null || _vectorLayer$getSourc2 === void 0 ? void 0 : _vectorLayer$getSourc2.clear();
    (_vectorLayer$getSourc3 = vectorLayer.getSource()) === null || _vectorLayer$getSourc3 === void 0 ? void 0 : _vectorLayer$getSourc3.addFeature(targetFeature);
  }, [map, vectorLayer]);
  return {
    highlightFeatureById
  };
}